function initCarouselNews() {
	if (document.querySelector('.js-carousel-news')) {
		let sliderNews = tns({
			container: '.js-carousel-news',
			autoplayButtonOutput: false,
			mode: 'gallery',
			navPosition: 'bottom',
			items: 1,
			speed: 1000,
			autoplay: true,
			mouseDrag: true,
			touch: true,
			controlsContainer: '.js-controls-news',
			responsive: {
				900: {
					items: 2
				}
			}
		});
	}
}

let sliders = {
	sliderEngagements: {},
	sliderOffers: {},
	sliderServices: {},
	sliderTestimonials: {}
};

function initCarousels() {
	// DESKTOP ONLY
	checkWindowWidth(null, null, () => {
		if (document.querySelector('.js-carousel-engagements')) {
			sliders.sliderEngagements = tns({
				container: '.js-carousel-engagements',
				autoplayButtonOutput: false,
				mode: 'gallery',
				nav: false,
				items: 4,
				speed: 0,
				autoplay: true,
				mouseDrag: true,
				touch: true,
				controlsContainer: '.js-controls-engagements'
			});
		}

		if (document.querySelector('.js-carousel-offers')) {
			sliders.sliderOffers = tns({
				container: '.js-carousel-offers',
				autoplayButtonOutput: false,
				mode: 'gallery',
				nav: false,
				items: 3,
				speed: 0,
				autoplay: true,
				mouseDrag: true,
				touch: true,
				controlsContainer: '.js-controls-engagements'
			});
		}

		if (document.querySelector('.js-carousel-services')) {
			sliders.sliderServices = tns({
				container: '.js-carousel-services',
				autoplayButtonOutput: false,
				mode: 'gallery',
				nav: false,
				items: 4,
				speed: 0,
				autoplay: true,
				mouseDrag: true,
				touch: true,
				controlsContainer: '.js-controls-services'
			});
		}
	});

	if (document.querySelector('.js-carousel-residence')) {
		// let sliderResidence = tns({
		// 	container: '.js-carousel-residence',
		// 	autoplayButtonOutput: false,
		// 	mode: 'gallery',
		// 	// nav: false,
		// 	navAsThumbnails: true,
		// 	items: 1,
		// 	speed: 500,
		// 	autoplay: true,
		// 	mouseDrag: true,
		// 	touch: true,
    //   controlsContainer: '.js-controls-residence',
    //   nav: false
		// 	// navContainer: '.js-nav-residence'
		// });

		// let navThumbnails = document.querySelector('.js-nav-residence');
		// let itemWidth = navThumbnails.querySelector('li').offsetWidth + 7;

		// console.log(itemWidth);

		// sliderResidence.events.on('indexChanged', (info) => {
		// 	let currentIndex = info.displayIndex;
		// 	const length = info.slideCount;

		// 	if (ww < 410 && length > 3) {
		// 		if (currentIndex < length) {
		// 			navThumbnails.style.transform = 'translateX(' + (1 - currentIndex) * itemWidth + 'px)';
		// 		} else {
		// 			navThumbnails.style.transform = 'translateX(' + (2 - length) * itemWidth + 'px)';
		// 		}
		// 	} else if (ww < 600 && length > 4) {
		// 		if (currentIndex < 2) {
		// 			navThumbnails.style.transform = 'translateX(0)';
		// 		} else if (currentIndex < length - 1) {
		// 			navThumbnails.style.transform = 'translateX(' + (2 - currentIndex) * itemWidth + 'px)';
		// 		} else {
		// 			navThumbnails.style.transform = 'translateX(' + (3 - length) * itemWidth + 'px)';
		// 		}
		// 	} else if (length > 4) {
		// 		if (currentIndex < 2) {
		// 			navThumbnails.style.transform = 'translateX(0)';
		// 		} else if (currentIndex < length - 2) {
		// 			navThumbnails.style.transform = 'translateX(' + (2 - currentIndex) * itemWidth + 'px)';
		// 		} else {
		// 			navThumbnails.style.transform = 'translateX(' + (4 - length) * itemWidth + 'px)';
		// 		}
		// 	}
		// });
	}

	if (document.querySelector('.js-carousel-testimonials')) {
		sliders.sliderTestimonials = tns({
			container: '.js-carousel-testimonials',
			autoplayButtonOutput: false,
			mode: 'gallery',
			navPosition: 'bottom',
			items: 1,
			speed: 1000,
			autoplay: true,
			mouseDrag: true,
			touch: true,
			controlsContainer: '.js-controls-testimonials',
			responsive: {
				700: {
					items: 2
				},
				1200: {
					items: 3
				}
			}
		});
	}

	if (document.querySelector('.js-carousel-home')) {
		let speed = 1000;

		let sliderHome = tns({
			container: '.js-carousel-home',
			autoplayButtonOutput: false,
			mode: 'gallery',
			nav: false,
			speed: speed,
			autoplay: true,
			mouseDrag: true,
			touch: true,
			controlsContainer: '.js-carousel-nav'
		});

		sliderHome.events.on('indexChanged', (info) => {
			let currentIndex = info.displayIndex;
			let section = document.querySelector('.js-section-carousel');
			let oldSlide = document.querySelector('.js-carousel-title.is-active');
			let newSlide = document.querySelector('.js-carousel-title[data-index="' + currentIndex + '"]');
			let controls = [ ...document.querySelectorAll('.js-carousel-home-arrow') ];

			oldSlide.classList.remove('is-active');

			setTimeout(() => {
				oldSlide.style.display = 'none';
				newSlide.style.display = 'block';
			}, 200);

			setTimeout(() => {
				newSlide.classList.add('is-active');
			}, 400);

			section.classList.remove(oldSlide.dataset.color);
			section.classList.add(newSlide.dataset.color);

			// DISABLE CONTROLS DURING ANIMATION
			controls.forEach((el) => (el.disabled = true));
			setTimeout(() => {
				controls.forEach((el) => (el.disabled = false));
			}, speed);
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	initCarousels();
	window.addEventListener(
		'resize',
		debounce(function() {
			Object.keys(sliders).forEach((el) => {
				if (!isEmpty(sliders[el])) {
					// console.log('slider services exists');
					if (sliders[el].destroy !== null) {
						// console.log('slider services destroy');
						sliders[el].destroy();
					}
					checkWindowWidth(null, null, () => {
						// console.log('slider services rebuild');
						sliders[el] = sliders[el].rebuild();
					});
				}
			});
		}, 500)
	);
});
